export const Name = 'add-basket-offer';
export const AddBasketOffer = Name;
export const isAddBasketOfferPurchaseEvent = event => typeof event.detail === 'object' && Boolean(event.detail.items);
//# sourceMappingURL=index.js.map